import NextHead from "../components/Seo/NextHead";
import Layout from "../components/Layout";
import Calculator from "../components/Calculator";
import ShopOfflineTerms from "../components/Shop/ShopOfflineTerms";
import PromoSlider from "../components/Promo/PromoSlider";
import ShopOfflineProduct from "../components/Shop/ShopOfflineProduct";

type KreditPagesProps = {
  query: string;
  promos: any;
  asPath: string;
  item: any;
};
const KreditPages = ({ query, promos, asPath, item }: KreditPagesProps) => {
  const { name, promo_code, subtitle, meta_title, meta_desc } = item;
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": process.env.baseURL,
        name: "Home"
      }
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseURL + asPath,
        name: name
      }
    }
  ];
  return (
    <Layout>
      <NextHead
        title={meta_title}
        description={meta_desc}
        url={asPath}
        breadcrumb={breadcrumb}
        tracker={query}
      />
      <ShopOfflineProduct title={name} subtitle={subtitle} path="" />
      <Calculator promocode={promo_code} asPath={asPath} />
      <ShopOfflineTerms />
      <PromoSlider promos={promos.slice(0, 6)} titledetailpromo={name} />
    </Layout>
  );
};

export default KreditPages;
